import {Actions, createEffect, ofType} from "@ngrx/effects";
import {inject} from "@angular/core";
import {VisitPlanHttpService} from "../../services/visit-plan-http.service";
import {VisitPlanActions, VisitPlanAPiActions, VisitPlanChannelActions} from "../visit-plan-state/visit-plan.actions";
import {catchError, exhaustMap, finalize, map, mergeMap, of} from "rxjs";
import {VisitPlanChannelService} from "../../services/visit-plan-channel.service";
import {
  VisitScheduleActions,
  VisitScheduleAPiActions,
  VisitScheduleChannelActions
} from "./visit-plan-schedule.actions";
import {VisitScheduleModel} from "../../../models/visit-schedule.model";
import {VisitScheduleChannelService} from "../../services/visit-schedule-channel.service";
import {VisitPlanAccountCellChannelService} from "../../services/visit-plan-account-cell-channel.service";
import {
  VisitPlanAccountActions,
  VisitPlanAccountChannelActions
} from "../visit-plan-account-state/visit-plan-account.actions";
import {CommonsFacadeService} from "../../../../commons/angular/state/commons/commons-facade.service";
import {VisitPlanModel} from "../../../models/visit-plan.model";
import {VisitScheduleOptimizationSettings} from "../../../models/visit-schedule-optimization-config.model";

export const initVisitSchedule = createEffect(
  (actions$ = inject(Actions),
   visitPlanHttpService = inject(VisitPlanHttpService),
   commonsFacadeService: CommonsFacadeService = inject(CommonsFacadeService)
  ) => {
    return actions$.pipe(
      ofType(VisitScheduleAPiActions.initVisitSchedule),
      mergeMap((payload) => {
        commonsFacadeService.setLoaderOn();
        return visitPlanHttpService.initVisitSchedule(payload.visitPlanId, payload.visitScheduleConfig).pipe(
          map((visitPlan: VisitPlanModel) => {
            return VisitScheduleAPiActions.initVisitScheduleSuccess({
              visitPlan,
              visitScheduleConfig: payload.visitScheduleConfig
            })
          }),
          catchError((error: {
            message: string
          }) => of(VisitScheduleAPiActions.initVisitScheduleFailure({error}))),
          finalize(() => {
            commonsFacadeService.setLoaderOff()
          })
        )
      })
    );
  },
  {functional: true}
);


export const getVisitSchedule = createEffect(
  (actions$ = inject(Actions),
   visitPlanHttpService = inject(VisitPlanHttpService),
  ) => {
    return actions$.pipe(
      ofType(VisitScheduleAPiActions.getVisitSchedule),
      mergeMap(payload => {
        return visitPlanHttpService.getVisitSchedule(payload.visitPlanId, payload.visitScheduleId).pipe(
          map((visitSchedule: VisitScheduleModel) => VisitScheduleAPiActions.getVisitScheduleSuccess({
            visitSchedule: visitSchedule,
            isSubscribeToChannel: payload.isSubscribeToChannel
          })),
          catchError((error: {
            message: string
          }) => of(VisitScheduleAPiActions.getVisitScheduleFailure({error})))
        )
      })
    );
  },
  {functional: true}
);

export const getVisitScheduleSuccess = createEffect(
  (actions$ = inject(Actions),
   visitScheduleChannelService = inject(VisitScheduleChannelService)) => {
    return actions$.pipe(
      ofType(VisitScheduleAPiActions.getVisitScheduleSuccess),
      map((payload) => {
        if (payload.isSubscribeToChannel) {
          visitScheduleChannelService.subscribeById(payload.visitSchedule.id);
        }
      })
    );
  },
  {functional: true, dispatch: false}
);

export const subscribeAllVisitPlansChannel = createEffect(
  (actions$ = inject(Actions),
   visitScheduleChannelService = inject(VisitScheduleChannelService)) => {
    return actions$.pipe(
      ofType(VisitScheduleChannelActions.subscribe),
      exhaustMap(() =>
        visitScheduleChannelService.getChannelsValues().pipe(
          map((notification) =>
            VisitScheduleChannelActions.notificationReceived({ notification })
          )
        )
      )
    );
  },
  { functional: true }
);

// export const subscribeAllVisitPlansChannel = createEffect(
//   (actions$ = inject(Actions),
//    visitScheduleChannelService = inject(VisitScheduleChannelService)) => {
//     return actions$.pipe(
//       ofType(VisitScheduleChannelActions.subscribe),
//       mergeMap(payload =>
//         visitScheduleChannelService.getChannelsValues().pipe(
//           map((notification) => {
//             return VisitScheduleChannelActions.notificationReceived({notification: notification})
//           })
//         )
//       )
//     );
//   },
//   {functional: true}
// );

export const setVisitSchedule = createEffect(
  (actions$ = inject(Actions),
   visitScheduleChannelService = inject(VisitScheduleChannelService)) => {
    return actions$.pipe(
      ofType(VisitScheduleActions.setOne),
      map((payload) => {
        if (payload.isSubscribeToChannel) {
          visitScheduleChannelService.subscribeById(payload.visitSchedule.id);
        }
      })
    );
  },
  {functional: true, dispatch: false}
);

export const unsubscribeVisitScheduleChannels = createEffect(
  (actions$ = inject(Actions),
   visitScheduleChannelService = inject(VisitScheduleChannelService)) => {
    return actions$.pipe(
      ofType(VisitScheduleActions.removeAll, VisitScheduleActions.clearStore),
      map(payload => {
          visitScheduleChannelService.unSubscribeAll();
          return VisitScheduleChannelActions.unsubscribeSuccess();
        }
      )
    );
  },
  {functional: true}
);
